<template>
  <i-header class="header">
    <div class="header__logo">{{ $route.meta.title }}</div>
    <div class="header__user" v-if="user">
      <i-icon type="md-person" size="18" class="header__icon" />
      {{ user.shop_name }} {{ user.user_name }} 様
    </div>
  </i-header>
</template>

<script>
import { Header, Icon } from 'view-design'
export default {
  components: {
    'i-header': Header,
    'i-icon': Icon,
  },
  computed: {
    user() {
      return this.$store.getters['User/getUser']
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  background: #fff;
  border-bottom: 1px solid rgba(0, 40, 100, 0.12);
  &__logo {
    display: flex;
    align-items: center;
    float: left;
    font-weight: bold;
    font-size: 16px;
    color: #333;
    line-height: normal;
  }
  &__icon {
    margin-right: 4px;
  }
}
</style>
